import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { ModalProps } from '../../../holidays/components/types'
import { createLeaveType } from '../../leavetypes/api'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { PolicyFormValues, NewLeaveType } from '../../types/index'
import { addLeaveType } from '../../leavetypes/slice/index'

const AddNewType = ({ show, onClose }: ModalProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Add  Leave Type"
            body={
                <Formik
                    initialValues={{
                        policyname: '',
                    }}
                    onSubmit={async (
                        values,
                        actions: FormikHelpers<PolicyFormValues>
                    ) => {
                        try {
                            dispatch(SHOW_LOADER())
                            const response = await createLeaveType({
                                leaveTypeName: values.policyname,
                            })
                            const newLeaveType: NewLeaveType = {
                                id: response.data,
                                title: values.policyname,
                                numberOfLeaves: 0,
                                isCarryOver: false,
                            }
                            dispatch(addLeaveType(newLeaveType))
                            if (response.status === 200) {
                                dispatch(
                                    SHOW_NOTIFICATION({
                                        message:
                                            'Leave type added successfully',
                                        type: 'success',
                                    })
                                )
                            }
                            actions.setSubmitting(false)
                            onClose(false)
                        } catch (error: any) {
                            dispatch(
                                SHOW_NOTIFICATION({
                                    message: error?.response?.data?.exception,
                                    type: 'error',
                                })
                            )
                            console.error('Error creating leave type:', error)
                        } finally {
                            dispatch(HIDE_LOADER())
                            actions.setSubmitting(false)
                            onClose(false)
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <InputField
                                type="text"
                                lable={''}
                                name="policyname"
                                value={values.policyname}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.policyname}
                                touched={touched.policyname}
                                defaultValue={'Post Title'}
                                placeholder=""
                            />
                            <div className="footer-block">
                                <Button disabled={isSubmitting} type="submit">
                                    Save
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="button"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default AddNewType
